// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Share_pageWrapper__1wwke"};